export default {"src":"/_next/static/media/trig.5b8655e6.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};